import { useAuth } from '@/auth/useAuth'

/**
 * True when the signed-in user manages customers and this is their own company (ORB-819).
 *
 * ⚑ Both halves. `CanManageCustomers` is worked out on the home company, and a customer created from
 * inside another company would be a customer of that company. So Admin for a managed customer shows no
 * Customers entry, the front door there offers no onboarding, and Webster's onboarding tools refuse it.
 */
export function useManagesCustomers(clientCompanyId: string): boolean {
  const { canManageCustomers, homeClientCompanyId } = useAuth()
  return Boolean(canManageCustomers) && homeClientCompanyId === clientCompanyId
}
